// Please see docs for API here: https://uk-test.optimalprint.net/api/doc
export default {
  login: '/api/auth/v1/login',
  logout: '/api/auth/v1/logout',
  refreshToken: '/api/auth/v1/refresh-token',
  register: '/api/auth/v1/register',
  registerGuest: '/api/auth/v1/register-guest',
  categoryV2List: '/api/category/v2/list',
  categoryV1List: '/api/category/v1/list',
  categoryV3DesignsList: '/api/category/v3/designs/list',
  categoryV2MatchingProductsList: '/api/category/v2/matching-products/list',
  routingV1List: '/api/app/routing/v1/list',
  cartV1AddressUpdate: '/api/customer/cart/v1/address/update',
  cartV1DesignAdd: '/api/customer/cart/v1/design/add',
  cartV1Get: '/api/customer/cart/v1/get',
  cartV1ItemDuplicate: '/api/customer/cart/v1/item/duplicate',
  cartV1ItemEnvelopeUpdate: '/api/customer/cart/v1/item/envelope/update',
  cartV1ItemQuantityUpdate: '/api/customer/cart/v1/item/quantity/update',
  cartV1ItemRemove: '/api/customer/cart/v1/item/remove',
  cartV1ItemRemoveAllBundledItems: '/api/customer/cart/v1/item/remove-all-bundled-items',
  cartV1ItemSubstrateUpdate: '/api/customer/cart/v1/item/substrate/update',
  cartV1Lock: '/api/customer/cart/v1/lock',
  cartV1PostPurchaseCampaign: '/api/customer/cart/v1/post-purchase/campaign',
  cartV1ProductAdd: '/api/customer/cart/v1/product/add',
  cartV1PublicDesignAdd: '/api/customer/cart/v1/public-design/add',
  cartV1ShippingMethodList: '/api/customer/cart/v1/shipping-method/list',
  cartV1ShippingMethodUpdate: '/api/customer/cart/v1/shipping-method/update',
  cartV1Unlock: '/api/customer/cart/v1/unlock',
  cartV1VoucherAdd: '/api/customer/cart/v1/voucher/add',
  cartV1VoucherRemove: '/api/customer/cart/v1/voucher/remove',
  productV1PriceList: '/api/product/v1/price/list',
  productV2PriceList: '/api/product/v2/price/list',
  categoryPageV1Get: '/api/category-page/v1/get',
  abstractProductPageV2Get: '/api/design/v2/abstract-product-page/get',
  translationV2List: '/api/translation/v2/list',
  shipmentPriceV2List: '/api/shipment-price/v2/list',
  shipmentPriceV2ListDetailed: '/api/shipment-price/v2/list-detailed',
  categoryGtmProducts: '/app-api/category/gtm-products',
  searchV1Regular: '/api/search/v1/regular',
  searchV2Regular: '/api/search/v2/regular',
  clerkV1Click: '/api/clerk/v1/click',
  recommendation: '/api/recommendation/v1/list',
  recommendationV2List: '/api/recommendation/v2/list',
  configuration: '/api/configuration/v1/list',
  configCatConfiguration: '/api/configuration/v2/list',
  customerCartV1PublicDesignAdd: '/api/customer/cart/v1/public-design/add',
  customerUpsellV1EditorScreen: '/api/customer/upsell/v1/editor-screen',
  upsellV1Screen: '/api/upsell/v1/screen',
  customerCartV1VoucherAdd: '/api/customer/cart/v1/voucher/add',
  customerCartV1ProductOPPlusGet: '/api/customer/cart/v1/product-opplus/get',
  productV1RecentlyViewedList: '/api/product/v1/recently-viewed/list',
  categoryV3DesignsSearch: '/api/category/v3/designs:search',
  gettyImagesV1Search: '/api/getty-images/v1/search',
  gettyImagesV1Get: '/api/getty-images/v1/get-images-by-ids',
  landingpageV1Get: '/api/landingpage/v1/get',
  contentfulPreviewData: '/contentful/json',
  gettyImagesV1StudioAbstractProduct: '/api/getty-images/v1/studio-abstract-product/get',
  productV2AbstractProductGet: '/api/product/v2/abstract-product/get',
  gettyImagesV1GetImageById: '/api/getty-images/v1/get-image-by-id',
  gettyImagesV1ArtistImages: '/api/getty-images/v1/artists/images',
  gettyImagesV1SimilarImages: '/api/getty-images/v1/similar/images',
  contentAppV1CreateProductPage: '/api/content/app/v1/create/product-page',
  publicDesignV3GetByProductId: '/api/design/v3/get-by-product-uid',
  customerDesignV3Add: '/api/customer/design/v3/add',
  communicationV1SmsSend: '/api/communication/v1/sms/send',
  trustpilotV1Get: '/api/trustpilot/v1/get',
  funnelV1Path: '/api/funnel/v1/path',
  customerOpPlusV2Info: '/api/customer/op-plus/v2/info',
  customerOpPlusV3Info: '/api/customer/op-plus/v3/info',
  customerProfileV1Get: '/api/customer/profile/v1/get',
  customerOpPlusV1CancelConfirmationPage: '/api/customer/op-plus/v1/cancel-confirmation-page',
  customerOpPlusV1CancellationReasons: '/api/customer/op-plus/v1/cancellation-reasons',
  customerOpPlusV1Cancel: '/api/customer/op-plus/v1/cancel',
  opPlusV1Cart: '/api/op-plus/v1/cart/add',
  rewardsV1Status: '/api/customer/rewards/v1/status',
  graphql: '/api/graphql/',
  rewardsSummaryV1: '/api/rewards/summary/v1',
  favouritesAddV1: '/api/v1/favourites/add',
  favouritesRemoveV1: '/api/v1/favourites/delete',
  favouritesGetV1: '/api/v1/favourites/list',
  publicAssetV1ProductPage: '/api/public-asset/v1/product-page',
  publicAssetV1Details: '/api/public-asset/v1/details',
  shipmentMethodV1List: '/api/shipment-method/v1/list',
  customerOrderV1List: '/api/customer/order/v1/list',
  searchFallback: '/api/search/v1/fallback',
  chatbotV1Reorder: '/api/chatbot/v1/orders/reorder',
  customerOrderV1Details: '/api/customer/order/v1/details',
};
